import React from 'react';

import './index.css';

export default function Loader() {
	return (
		<svg className="circular" height="50" width="50">
			<circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="2" strokeMiterlimit="10"></circle>
		</svg>
	)
}



// WEBPACK FOOTER //
// ./src/components/Loader/index.js